import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

interface PanelProps {
  title: string;
  description?: React.ReactNode;
  children: React.ReactNode;
}

/** A titled box; every block on the cost pages is one. */
export const CostPanel: React.FC<PanelProps> = ({ title, description, children }) => (
  <Paper variant="outlined" component="section" sx={{ p: 2 }}>
    <Typography variant="h6" component="h2" sx={{ fontWeight: 700 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        {description}
      </Typography>
    )}
    {!description && <Box sx={{ mb: 1 }} />}
    {children}
  </Paper>
);

interface FigureProps {
  label: string;
  value: string;
  hint?: string;
}

/** One number with its label, for the rows of figures at the top of a tab. */
export const Figure: React.FC<FigureProps> = ({ label, value, hint }) => (
  <Box component="div" sx={{ minWidth: 0 }}>
    <Typography component="dt" variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography component="dd" variant="h6" sx={{ m: 0, fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
      {value}
    </Typography>
    {hint && (
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
        {hint}
      </Typography>
    )}
  </Box>
);

export const Figures: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <Box
    component="dl"
    aria-label={label}
    sx={{ m: 0, display: 'grid', gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: 'repeat(4, minmax(0, 1fr))' }, gap: 2 }}
  >
    {children}
  </Box>
);
